import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})

/*----------------------------- Support service for responsive layouts ----------------------------------------*/

export class UiWindowService {

  private ratioMedium = 0.6;
  private ratioLarge = 0.8;
  private ratioFull = 1;

  public minWidth = 400;
  public minHeight = 200;

  public calculatedWidthMedium = new BehaviorSubject<number>(window.innerWidth * this.ratioMedium);

  public calculatedHeightMedium = new BehaviorSubject<number>(window.innerHeight * this.ratioMedium);
  public calculatedHeightLarge = new BehaviorSubject<number>(window.innerHeight * this.ratioLarge);
  public calculatedHeightFull = new BehaviorSubject<number>(window.innerHeight * this.ratioFull);

  // page height for menu...?

  constructor() {
    window.onresize = (e) => {
      this.calculatedWidthMedium.next(Math.max((<Window>e.target).innerWidth * this.ratioMedium, this.minWidth));
      this.calculatedHeightMedium.next(Math.max((<Window>e.target).innerHeight * this.ratioMedium, this.minHeight));
      this.calculatedHeightLarge.next(Math.max((<Window>e.target).innerHeight * this.ratioLarge, this.minHeight));
      this.calculatedHeightFull.next(Math.max((<Window>e.target).innerHeight * this.ratioFull));
    }
  }
}
